import React from 'react';
import { TableCell } from '@material-ui/core';
import { DropdownMenu } from '@nearst/ui';

import styles from './CategorySummary.module.scss';

const Category = ({ row }) => {
	return (
		<TableCell>
			{!row.category_titles?.length ? null : (
				<DropdownMenu
					buttonText={<span className={styles.mainCategoryTitle}>{row.category_titles[0]}</span>}
					className={styles.dropdown}
					innerClassName={styles.dropdownInner}
				>
					<p className={styles.categoryTitle}>Product category</p>
					<p className={styles.categoryValue}>{row.category_full_trees.join(', ')}</p>
				</DropdownMenu>
			)}
		</TableCell>
	);
};

export { Category };
